import { BaseDataModel } from "@domain/shared/types/BaseDataModel";

export class Deal extends BaseDataModel {
	name!: string;
	density!: number;
	testPackage!: string;
	depth!: number;
	frequencyOfMicros?: number;
	sitesType!: string;
	season!: string;
	syncMethod?: string;
	syncMethod2?: string;
	labAccountNumber!: string;
	testCompanyName?: string;
	customizer?: string;
	labName!: string;
	isActive!: boolean;
	isConfigOnly!: boolean;
	isComposite!: boolean;
	isMultiComposite!: boolean;
	isPtsRequired!: boolean;
	companyId!: string;
	fieldParameters: string[] = [];
	samplingTypeSpecial?: string;
	labPackage?: string;
	mapAndDataSourceContact?: string;
	priceType?: string;
	serviceLevel?: string;
	cores?: number;
	coresPerStop?: number;
	patternSizeFt?: number;
	abLineEastDefinition?: number;
	turnTimeDays?: number;
	pattern?: string;
	jobsSubmissionProcess?: string;
	customerSoftware?: string;
	labResultsEmail?: string;
	softwareDataNotes?: string;
	autoSyncLabResults!: boolean;
	autoSyncPtEdits!: boolean;
	autoSyncBndEdits!: boolean;
	majorBoundaryCollect?: number;
	minorBoundaryCollect?: number;
	inseasonUpchargePotentialPct?: number;
	labAddOnPerSample?: number;
	specialtyAddOn?: number;
	baseSamplingDollarsPerAcre?: number;
	shippingDollarsPerAcre?: number;
	labBasePerSample?: number;
	turnUpcharge?: number;
	coresUpcharge?: number;
	depthUpcharge?: number;
	patternUpcharge?: number;
	ovrdForRogoAdjustedPrice?: number;
	rogoSpecialDiscountsDollarsPerAcre?: number;
	secondEntityDollarsPerAcre?: number;
	pricePerField?: number;
	fieldSizeUpcharge?: number;
	avgFieldSize?: number;
	dpPercent?: number;
	paymentTimingDays?: number;
	paidBoundaryCollect!: boolean;
	fieldDiscretion!: boolean;
	minorBoundaryAwareness!: boolean;
	frozenGroundOk?: string;
	criticalCreditNotes?: string;
	zoneInterleavingAllowed!: boolean;
	samplingToleranceFt?: number;
	restrictedBarcodeTypesDeal: string[] = [];
	samplingSop?: string;
	coreDiameter?: string;
	testClient: string[] = [];
	status?: string;
	isPrimary!: boolean;
	dealType?: string;
	patternAngleDegFromEast?: number;
	thirdPartyIdRollupFromBranches?: string;
	url!: string;
}
